// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Retailers/index.css
// module id = 1737
// module chunks = 0